export const AuthUserProfile = {
  GENERAL_ADMIN: 'GENERAL_ADMIN',
  CREW_ADMIN: 'CREW_ADMIN',
  CREW_ADMIN_AUX: 'CREW_ADMIN_AUX',
  DOT_ADMIN: 'DOT_ADMIN',
  COMMANDER: 'COMMANDER',
  PILOT: 'PILOT',
  FLIGHT_ATTENDANT: 'FLIGHT_ATTENDANT',
  CREW_AUX: 'CREW_AUX',
  CLC: 'CLC',
  TRC: 'TRC',
  CHIEF_COORDINATOR: 'CHIEF_COORDINATOR',
  SUPERVISING_COORDINATOR: 'SUPERVISING_COORDINATOR',
  AGENT_COORDINATOR: 'AGENT_COORDINATOR',
  CHIEF_RAMP_AGENT: 'CHIEF_RAMP_AGENT',
  SUPERVISING_RAMP_AGENT: 'SUPERVISING_RAMP_AGENT',
  RAMP_AGENT: 'RAMP_AGENT',
} as const;

export type AuthUserProfile = (typeof AuthUserProfile)[keyof typeof AuthUserProfile];

export const CREW_ADMIN_PROFILES: ReadonlySet<AuthUserProfile> = new Set([
  AuthUserProfile.GENERAL_ADMIN,
  AuthUserProfile.CREW_ADMIN,
  AuthUserProfile.CREW_ADMIN_AUX,
]);
